import axios from 'axios'

class HealthVaultService {
  constructor() {
    this.baseUrl = '/api/v1/healthvaults/'
  }

  getHealthVaultTags() {
    return axios.get(`${this.baseUrl}get-health-vault-tags/`)
  }

  getDocuments(filter) {
    return axios.post(`${this.baseUrl}get-hv-documents/`, filter)
  }

  uploadHealthVault(document) {
    const headers = { 'Content-Type': 'multipart/form-data' }
    return axios.post(`${this.baseUrl}save-hv-documents/`, document, {
      headers,
    })
  }

  updateHealthVault(document) {
    return axios.put(`${this.baseUrl}update-hv-documents/`, document)
  }

  deleteDocuments(documents) {
    return axios.post(`${this.baseUrl}delete-hv-documents/`, documents)
  }

  getSharedDocument(filter) {
    return axios.post(`${this.baseUrl}get-shared-hv-documents/ `, filter)
  }

  getReceivedDocument(filter) {
    return axios.post(`${this.baseUrl}received-documents/ `, filter)
  }

  getDocumentFiles(documentId) {
    return axios.post(`${this.baseUrl}get-hv-file/ `, {
      document_id: documentId,
    })
  }

  revokeDocument(data) {
    return axios.post(`${this.baseUrl}hv-update-revoke-access/ `, data)
  }
}

export const healthVaultService = new HealthVaultService()
